<template>
    <div class="city">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>城市管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>城市列表</h2>
                <div class="item" @click="addCity"><i class="icon el-icon-circle-plus" type="primary"></i>新增城市</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="城市名称">
                        <el-input v-model="city_name" placeholder="请输入城市名称" clearable @clear="getCityList()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="cityList"
                        border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            prop="city_id"
                            label="城市ID"
                            width="150"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="城市名称"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="area_list"
                            label="区域"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <template v-if="scope.row.area_list.length>0">
                                <span v-for="(item,i) in scope.row.area_list" :key="i" style="margin: 0 4px;">{{item.name}}</span>
                            </template>
                            <template v-else>
                                <span>暂无</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="realname"
                            label="联系人"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="联系人电话"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateClick(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCityList} from "../../api/city";

    export default {
        name: "city",
        data(){
            return{
                cityList:[],
                page:1,
                pages:1,
                city_name:'',
                formInline: {
                    user: '',
                    region: ''
                },
            }
        },
        mounted(){
            this.getCityList();
        },
        methods:{
            getCityList(){
                getCityList({
                    city_name:this.city_name,
                    p:this.page
                }).then(res=>{
                    if(res.code==1){
                        this.cityList=res.data.list;
                        this.pages=res.data.total_page;
                    }
                })
            },
            onSubmit(){
                this.getCityList();
            },
            updateClick(){

            },
            handleCurrentChange(val) {
                this.page=val;
                this.getCityList()
            },
            addCity(){
                this.$router.push({path: '/city/add'});
            },
        }

    }
</script>

<style lang="scss" scoped>
.top-box{
    width: 100%;
    height: 100px;
    background-color: #ffffff;
    padding: 20px;
    .tab-list{
        margin-top: 20px;
        h2{
            margin-right: 20px;
            padding-right: 20px;
            border-right: 1px solid #eaeaea;
        }
        .item{
            font-size: 16px;
            color: #409EFF;
            display: flex;
            align-items: center;
            cursor: pointer;
            .icon{
                font-size: 20px;
                color: #409EFF;
                margin-right: 5px;
            }
        }
    }

}
.page-content{
    padding: 20px;

    .table{
        text-align: left;
        width: 100%;
        background-color: #fff;
        padding: 30px;
        box-shadow: 0 0 10px #eaeaea;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }
}
</style>
